export default __webpack_public_path__ + "static/media/user_activity_64.993a112f.png";